var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"tourHolder"},[_c('Loading',{attrs:{"loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }